import styled from 'styled-components';

import { SIZE, LIGHT_BLUE } from '../../const';

export const StyledSearchResult = styled.div`
    width: 100%;
    dispay:flex;
    flex-direction: column;

    .title {
        font-weight: bold;
        font-size: 28px;
        margin-bottom: 40px;
        color: ${LIGHT_BLUE};
    }

    .item {
        gap: 30px;
    }

    @media ${SIZE.tablet} {
        .item {
            gap: 17px;
        }
    }
`;